import { RunningLine } from 'components/RunningLine'

import { Reviews } from 'blocks/Reviews'

import { HelmetFunc } from 'components/PageMetaData'

import React, { useEffect, useRef, useState } from 'react'
import styled, { css } from 'styled-components'

import { backgroundColors, colors } from 'styles/colors'

import { displayWidth } from 'styles/width'

import { useTranslation } from 'react-i18next'
import { sendEvent, gtag } from 'tracking'

import Proposal from 'assets/icons/proposal.svg'
import Pensile from 'assets/icons/pensile.svg'
import Handshake from 'assets/icons/handshake.svg'

import { mobileAfterBorder } from 'styles/mobileAfterBorder'
import { ComercialForm } from 'components/form/CommercialForm'
import { CommercialProposalFormBlock } from 'blocks/CommercialProposalFormBlock'

import { Header } from 'blocks/Header/Header'
import { graphql } from 'gatsby'
import { usePagePath } from 'hooks/usePagePath'
import {
    ProjectStructureQuestion,
    ProjectStructureQuestionDesktop,
} from 'blocks/ProjectStructureQuestion'
import { ProjectStructureWhy } from 'blocks/ProjectStructureWhy'
import { MobileMenuPosadka } from 'components/MobileMenuPosadka'
import { PosadkaLinkBlock } from 'components/PosadkaLinkBlock'
import { PromoHero } from 'blocks/Heros/PromoHero'
import { ExamplesOfProjects } from 'blocks/ExamplesOfProjects'
import {
    ServicesItemPropNew,
    ServicesItemNew,
} from 'blocks/Services/ServicesItem'
import { getDataByLanguage } from 'utils/getDataByLanguage'
import { Container } from 'components/Container'
import { LeftSidebar, RightSidebar } from 'components/SideBar'

const Desktop = styled.div`
    position: relative;
    display: none;
    width: 100%;
    height: 100%;
    @media (min-width: ${displayWidth.tablet}) {
        display: block;
    }
`
const Wrap = styled.div`
    top: 66px;
    height: calc(100vh - 126px);
    left: 0;
    right: 0;
    bottom: 60px;
    position: absolute;
    overflow: auto;
    @media (min-width: ${displayWidth.tablet}) {
        display: none;
    }
`
const WrapDesktop = styled.div`
    display: none;
    @media (min-width: ${displayWidth.tablet}) {
        display: block;
        top: 80px;
        height: calc(100vh - 80px);
        left: 0;
        right: 0;
        bottom: 60px;
        position: absolute;
        overflow: auto;
    }
`
const TitleNew = styled.h2`
    text-transform: uppercase;
    font-size: 25px;
    line-height: 35px;
    font-weight: bold;
    margin: 30px 40px 5px;
    text-align: center;
    @media (min-width: ${displayWidth.tablet}) {
        margin: 40px auto 0;
    }
`
const Arrow = styled.span`
    --arrow-height: 100px;
    --arrow-indent: 5px;
    content: '';
    --arrow-bottom: calc(-1 * var(--arrow-height) - var(--arrow-indent));
    position: absolute;
    bottom: var(--arrow-bottom);
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    display: block;
    width: 0;
    height: 0;
    border-left: var(--arrow-height) solid transparent;
    border-right: var(--arrow-height) solid transparent;
    border-top: var(--arrow-height) solid ${backgroundColors.vizualization};
`

const ContactsWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`

const pageMetadata = {
    uk: {
        title: 'Дизайн проект квартири у Києві за 99$',
        description:
            "Дизайн студія ClearLine розробляє дизайн проекти квартир, будинків, комерційних приміщень у Києві, займається декоруванням інтер'єру та екстер'єру",
    },
    ru: {
        title: 'Дизайн проект квартиры в Киеве за 99$',
        description:
            'Дизайн студия ClearLine разрабатывает дизайн проекты квартир, домов, коммерческих помещений в Киеве, занимается декорированием интерьера и єкстерьера',
    },
    en: {
        title: 'Design project of an apartment in Kyiv for $99',
        description:
            'Design studio ClearLine develops design projects for apartments, houses, commercial premises in Kyiv, is engaged in interior and exterior decoration',
    },
}

const svgStyle = css`
    width: 40px;
    min-width: 40px;
    margin-right: 10px;
`
const HandshakeS = styled(Handshake)`
    ${svgStyle}
`
const PensileS = styled(Pensile)`
    ${svgStyle}
`
const ProposalS = styled(Proposal)`
    ${svgStyle}
`
const FormColumn = styled.div`
    position: relative;
    ${mobileAfterBorder};
    width: 100%;
    padding: 0 24px 30px;
    box-sizing: border-box;
    background-color: ${backgroundColors.vizualization};
    h3 {
        display: flex;
        align-items: center;
        font-size: 20px;
        line-height: 24px;
        padding: 10px 0;
    }
`
const DivS = styled.div`
    margin: 0 10px 30px;
`
const FormTitle = styled.div<{ text?: boolean }>`
    font-family: 'Yeseva One', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 1px;
    ${({ text }) =>
        text === true
            ? `color:${colors.dark};font-size: 24px;`
            : `color: #437b13;font-size: 34px;`}

    text-align: center;
    padding: 40px 0 24px;
    white-space: pre-wrap;
    @media (min-width: ${displayWidth.tablet}) {
        text-align: left;
        margin: 60px 0 24px;
        width: 350px;
    }
    @media (min-width: ${displayWidth.desktop}) {
        width: 100%;
    }
`
const ServicesListStyled = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 0 0 16px;
    ${mobileAfterBorder};
    @media (min-width: ${displayWidth.tablet}) {
        margin: 16px 0px;
    }
`
const ServiceItemWrapper = styled.div<{ marginBottom: boolean }>`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${({ marginBottom }) => (marginBottom ? '105px' : '5px')}; ;
`

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Posadka = ({ data }: { data: any }) => {
    const { i18n, t } = useTranslation()
    const [isAnswerVisible, setIsAnswerVisible] = useState(-1)
    const { getPagePath } = usePagePath()
    const scrolled25Send = useRef(false)
    const scrolled50Send = useRef(false)
    const scrolled75Send = useRef(false)
    const scrolled100Send = useRef(false)

    const pagePath = getPagePath(i18n.language)

    const { questions } = getDataByLanguage(
        data.allServicesNewYaml,
        i18n.language
    )

    // Reset scroll event when page changes
    useEffect(() => {
        scrolled25Send.current = false
        scrolled50Send.current = false
        scrolled75Send.current = false
        scrolled100Send.current = false
        gtag('config', `${process.env.GA_ID}`, {
            // eslint-disable-next-line camelcase
            page_location: document.location,
        })
    }, [pagePath])

    const onScroll = () => {
        const block = document.getElementById('blockF')
        const scrollPosition = block!.scrollTop
        const windowHeight = block!.clientHeight
        const bodyHeight = block!.scrollHeight
        const blockMod = document.getElementById('wrap')
        const scrollPositionMob = blockMod!.scrollTop
        const windowHeightMob = blockMod!.clientHeight
        const bodyHeightMob = blockMod!.scrollHeight
        setTimeout(() => {
            const trackScroll = () => {
                const scrolledRation = Math.ceil(
                    ((scrollPosition + windowHeight) / bodyHeight) * 100
                )
                if (
                    block &&
                    !scrolled100Send!.current &&
                    scrolledRation >= 100
                ) {
                    sendEvent('100', {
                        eventCategory: 'ScrollDepth',
                    })
                    scrolled100Send!.current = true
                    return
                }

                if (block && !scrolled75Send!.current && scrolledRation >= 75) {
                    sendEvent('75', {
                        eventCategory: 'ScrollDepth',
                    })
                    scrolled75Send!.current = true
                    return
                }

                if (block && !scrolled50Send!.current && scrolledRation >= 50) {
                    sendEvent('50', {
                        eventCategory: 'ScrollDepth',
                    })
                    scrolled50Send!.current = true
                    return
                }

                if (block && !scrolled25Send!.current && scrolledRation >= 25) {
                    sendEvent('25', {
                        eventCategory: 'ScrollDepth',
                    })
                    scrolled25Send!.current = true
                }
            }
            const trackScrollMob = () => {
                const scrolledRationMob = Math.ceil(
                    ((scrollPositionMob + windowHeightMob) / bodyHeightMob) *
                        100
                )
                if (
                    block &&
                    !scrolled100Send!.current &&
                    scrolledRationMob >= 100
                ) {
                    sendEvent('100', {
                        eventCategory: 'ScrollDepth',
                    })
                    scrolled100Send!.current = true
                    return
                }

                if (
                    block &&
                    !scrolled75Send!.current &&
                    scrolledRationMob >= 75
                ) {
                    sendEvent('75', {
                        eventCategory: 'ScrollDepth',
                    })
                    scrolled75Send!.current = true
                    return
                }

                if (
                    block &&
                    !scrolled50Send!.current &&
                    scrolledRationMob >= 50
                ) {
                    sendEvent('50', {
                        eventCategory: 'ScrollDepth',
                    })
                    scrolled50Send!.current = true
                    return
                }

                if (
                    block &&
                    !scrolled25Send!.current &&
                    scrolledRationMob >= 25
                ) {
                    sendEvent('25', {
                        eventCategory: 'ScrollDepth',
                    })
                    scrolled25Send!.current = true
                }
            }
            trackScrollMob()
            trackScroll()
        }, 700)
    }
    return (
        <div>
            <HelmetFunc data={pageMetadata} />
            <Wrap id="wrap" onScroll={onScroll}>
                <MobileMenuPosadka />
                <PosadkaLinkBlock />
                <PromoHero
                    title={t('designKyiv')}
                    imagesData={data.allImageSharp}
                />
                <div id="projectStructure1" />
                <ProjectStructureQuestion data={data} />
                <ServicesListStyled>
                    <TitleNew>{t('howWeWork')}</TitleNew>
                    {questions.map(
                        (item: ServicesItemPropNew, index: number) => {
                            return (
                                <ServiceItemWrapper
                                    marginBottom={questions.length > index + 1}
                                    key={index}
                                >
                                    <ServicesItemNew
                                        setIsAnswerVisible={setIsAnswerVisible}
                                        isAnswerVisible={isAnswerVisible}
                                        name={index}
                                        title={item.title}
                                        question={item.question}
                                        answer={item.answer}
                                        justText={true}
                                    />
                                    {questions.length > index + 1 && <Arrow />}
                                </ServiceItemWrapper>
                            )
                        }
                    )}
                </ServicesListStyled>
                <RunningLine inverse>{t('designProject99')}</RunningLine>
                <Reviews arrows bottom />
                <ProjectStructureWhy />
                <ExamplesOfProjects />
                <FormColumn>
                    <FormTitle text>
                        {t('ComercialProposalFormTitle')}
                    </FormTitle>

                    <DivS>
                        <h3>
                            <ProposalS /> {t('comercialForm.proposal')}
                        </h3>
                        <h3>
                            <PensileS />
                            {t('comercialForm.example')}
                        </h3>
                        <h3>
                            <HandshakeS /> {t('comercialForm.conditions')}
                        </h3>
                    </DivS>

                    <ComercialForm placement="PosadkaMobileZa99" />
                </FormColumn>
            </Wrap>

            <Desktop id="blockF" onScroll={onScroll}>
                <Header />
                <WrapDesktop>
                    <PromoHero
                        title={t('designKyiv')}
                        price="99$"
                        imagesData={data.allImageSharp}
                    />
                    <RunningLine inverse>{t('designProject99')}</RunningLine>
                    <ProjectStructureQuestionDesktop data={data} />
                    <ContactsWrapper>
                        <LeftSidebar background={colors.white} />
                        <Container style={{ margin: '0 auto' }}>
                            <TitleNew>{t('howWeWork')}</TitleNew>
                            <ServicesListStyled>
                                {questions.map(
                                    (
                                        item: ServicesItemPropNew,
                                        index: number
                                    ) => {
                                        return (
                                            <ServiceItemWrapper
                                                key={index}
                                                marginBottom={
                                                    questions.length > index + 1
                                                }
                                            >
                                                <ServicesItemNew
                                                    setIsAnswerVisible={
                                                        setIsAnswerVisible
                                                    }
                                                    isAnswerVisible={
                                                        isAnswerVisible
                                                    }
                                                    name={index}
                                                    title={item.title}
                                                    question={item.question}
                                                    answer={item.answer}
                                                    justText={true}
                                                />
                                                {questions.length >
                                                    index + 1 && <Arrow />}
                                            </ServiceItemWrapper>
                                        )
                                    }
                                )}
                            </ServicesListStyled>
                        </Container>
                        <RightSidebar />
                    </ContactsWrapper>
                    <Reviews />
                    <RunningLine>{t('designProject99')}</RunningLine>
                    <ProjectStructureWhy />
                    <ExamplesOfProjects />
                    <CommercialProposalFormBlock placement="PosadkaZa99" />
                </WrapDesktop>
            </Desktop>
        </div>
    )
}

export default Posadka

export const query = graphql`
    query {
        allServicesNewYaml {
            edges {
                node {
                    questions {
                        title
                        question
                        answer
                    }
                    parent {
                        ... on File {
                            name
                        }
                    }
                }
            }
        }
        allImageSharp: allFile(
            filter: {
                sourceInstanceName: { eq: "images" }
                extension: { in: ["jpg", "jpeg", "png", "webp"] }
            }
        ) {
            edges {
                node {
                    childImageSharp {
                        fluid(srcSetBreakpoints: [800]) {
                            originalName
                            ...GatsbyImageSharpFluid
                        }
                    }
                    parent {
                        ... on File {
                            name
                        }
                    }
                }
            }
        }
        allProjectStructureQuestionYaml {
            edges {
                node {
                    title
                    price
                    image
                    promo
                    items {
                        question
                        answer
                        svg
                    }
                    parent {
                        ... on File {
                            name
                        }
                    }
                }
            }
        }
    }
`
